import request from '../request'

/**
 * 查询出版打印详情
 * @param {String} id - 出版打印记录ID
 */
///cosys/design/publish/detail/{id}
export function fetchPublishPrintDetail(id) {
    return request({
        url: `/project-service/cosys/design/publish/detail/${id}`,
        method: 'GET'
    })
}

/**
 * 重新提交出版打印（仅Reject/Cancel状态可操作）
 * @param {Object} data - 出版打印申请数据
 */
export function resubmitPublishPrint(data) {
    return request({
        url: '/project-service/cosys/design/publish/reapply',
        method: 'POST',
        data
    })
}
